import { Component } from 'react';
import withSubscription from './withSubscription';
import context from './api/context';

class OptionInfo extends Component {
  render() {
    return this.props.children(this.props.info);
  }
}

export default withSubscription(({ option }) => (option ? { info: context.option(option) } : {}))(OptionInfo);


// WEBPACK FOOTER //
// ./src/OptionInfo.js